module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_3016.2f76f399.png";